import React from 'react';
import type { TpQuickReadRow, TpQuickReadTone } from '../../patient-treatment/types';
import { PatientProfileTabSectionHeader } from './PatientProfileTabSectionHeader';

const TONE_DOT: Record<TpQuickReadTone, string> = {
  positive: 'var(--success)',
  warning: 'var(--gold)',
  negative: 'var(--terracotta)',
  neutral: 'var(--ink-4)',
};

export interface PatientTreatmentQuickReadProps {
  rows: TpQuickReadRow[];
}

export function PatientTreatmentQuickRead({ rows }: PatientTreatmentQuickReadProps) {
  return (
    <section className="tc-rise tc-d2 mb-[26px]">
      <PatientProfileTabSectionHeader
        eyebrow="Read in 5 seconds"
        title="Who you're talking to"
        icon="team"
        accent="var(--ink-3)"
      />
      <div className="tc-card py-1">
        {rows.map((row, i) => (
          <div
            key={row.label}
            className="grid grid-cols-[158px_1fr_auto] items-center gap-4 px-[22px] py-3"
            style={{ borderTop: i === 0 ? 'none' : '1px solid var(--cream-2)' }}
          >
            <span className="tc-eyebrow">{row.label}</span>
            <div className="text-[13.5px] leading-[1.5] tracking-[-0.005em] text-[var(--ink-1)]">
              {row.value}
            </div>
            <span
              className="h-2 w-2 rounded-full"
              style={{ background: TONE_DOT[row.tone] }}
              aria-hidden
            />
          </div>
        ))}
      </div>
    </section>
  );
}
